import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f4bfd92c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header_city"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-info mb15"
}, "Categories", -1));

const _hoisted_3 = {
  class: "flx-wrap jus-con-start"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-info"
}, "Price", -1));

const _hoisted_5 = {
  class: "slider-wrapper"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-info"
}, "Date", -1));

const _hoisted_7 = {
  class: "jus-con-sp-bet date-picker-wrapper"
};
const _hoisted_8 = {
  class: "events_container"
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import useMainStore from '@/store';
import { Close } from '@element-plus/icons-vue';
import CardComp from './CardComp.vue';
import PopupDrawer from '@/ui/PopupDrawer.vue';
export default {
  __name: 'EventsPopup',

  setup(__props) {
    const store = useMainStore();
    const {
      changeFilterIsActive,
      setEventsPopupVisibility,
      setEventsByPoint
    } = store;
    const {
      eventsPopupVisibility,
      eventsCategories,
      filteredEvents,
      chosenCity,
      eventsByPoint,
      maxPriceFilter
    } = storeToRefs(store);

    const onEventsPopupClose = () => {
      setEventsPopupVisibility(false);
      setEventsByPoint(null);
    };

    const data = computed(() => {
      return !eventsByPoint.value ? filteredEvents.value : eventsByPoint.value;
    });
    const marks = computed(() => ({
      0: '0',
      [maxPriceFilter.value]: '' + maxPriceFilter.value
    }));
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_slider = _resolveComponent("el-slider");

      const _component_DatePicker = _resolveComponent("DatePicker");

      return _openBlock(), _createBlock(PopupDrawer, {
        isOpen: _unref(eventsPopupVisibility),
        onClose: onEventsPopupClose
      }, {
        header: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString(_unref(chosenCity).value.value) + ", " + _toDisplayString(_unref(chosenCity).value.country), 1)]),
        default: _withCtx(() => [!_unref(eventsByPoint) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(eventsCategories), filter => {
          return _openBlock(), _createBlock(_component_el_button, {
            key: filter.id,
            type: filter.isActive ? 'primary' : undefined,
            onClick: $event => _unref(changeFilterIsActive)(filter.id)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(filter.label) + " ", 1), filter.isActive ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_unref(Close))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["type", "onClick"]);
        }), 128))]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_slider, {
          modelValue: _unref(store).priceRange,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(store).priceRange = $event),
          range: "",
          "show-stops": "",
          max: _unref(maxPriceFilter),
          marks: _unref(marks)
        }, null, 8, ["modelValue", "max", "marks"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_DatePicker, {
          placeholder: "Date From",
          teleportCenter: "",
          modelValue: _unref(store).dateTimeRangeFilter[0],
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(store).dateTimeRangeFilter[0] = $event),
          modelType: "timestamp",
          format: "dd/MM/yyyy HH:mm",
          selectText: "Select",
          cancelText: "Cancel",
          hideInputIcon: "",
          inputClassName: "dp-cus-input"
        }, null, 8, ["modelValue"]), _createVNode(_component_DatePicker, {
          placeholder: "Date To",
          teleportCenter: "",
          modelValue: _unref(store).dateTimeRangeFilter[1],
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(store).dateTimeRangeFilter[1] = $event),
          modelType: "timestamp",
          format: "dd/MM/yyyy HH:mm",
          selectText: "Select",
          cancelText: "Cancel",
          hideInputIcon: "",
          inputClassName: "dp-cus-input"
        }, null, 8, ["modelValue"])])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), event => {
          return _openBlock(), _createBlock(CardComp, _mergeProps({
            key: event.id
          }, event, {
            isBriefVersion: true
          }), null, 16);
        }), 128))])]),
        _: 1
      }, 8, ["isOpen"]);
    };
  }

};